import { DoorConfiguration as contex } from '../DoorConfiguration';
import * as helper from './Shared';

import store from '@/store/index';
import { Characteristic, ValueDefinition } from '../types';

// KTU_MM_FERMACELL_BREITE_A_TEIL
export const calculateFermacellBreiteATeil = () => {
    let result: number = 0;
    const wallThickness = helper.GetMainCharacteristicValue('KTU_MM_WANDDICKE', contex.Functions );

    const wallType = helper.GetDependencyValueCode('KTU_MM_WANDART_BESTAND', contex.Functions);
    const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    const framModel = helper.GetDependencyValueCode('KTU_MM_ZARGEN_KURZFORM', contex.Frame);

    switch (wallType) {
        case '1':
        case '2':
        case '3':
            switch (fireResistance) {
                case '30':
                    switch (framModel) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = wallThickness - 20;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallThickness - 10;
                            break;
                        case 'ES':
                        case 'EB':
                            result = 40;
                            break;
                        case 'ES-SV2':
                            result = 40;
                            break;
                        case 'EB-SV2':
                            result = 40;
                            break;
                        default:
                            result = result; // 0
                            break;
                    }
                    break;
                case '0':
                    result = result; // 0
                    break;
            }
            break;
        case '4':
            switch (fireResistance) {
                case '30':
                    switch (framModel) {
                        case 'US':
                        case 'USB':
                        case 'ES-SST':
                        case 'ES-SV1':
                            result = wallThickness - 20;
                            break;
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallThickness - 10;
                            break;
                        case 'ES-SV2':
                            result = 40;
                            break;
                        case 'EB-SV2':
                            result = 40;
                            break;
                        default:
                            result = result; // 0
                            break;
                    }
                    break;
                    case '0':
                        result = result; // 0
                        break;
            }
            break;
        case '5':
            switch (fireResistance) {
                case '30':
                    switch (framModel) {
                        case 'UB':
                            result = wallThickness - 10;
                            break;
                        case 'ES':
                        case 'EB':
                            result = 40;
                            break;
                        default:
                            result = result; // 0
                            break;
                    }
                    break;
                    case '0':
                        result = result; // 0
                        break;
            }
            break;
        case '6':
            switch (fireResistance) {
                case '30':
                    switch (framModel) {
                        case 'UB':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallThickness - 10;
                            break;
                        case 'EB':
                            result = 40;
                            break;
                        case 'ES':
                            result = 40;
                            break;
                        case 'EB-SV2':
                            result = 40;
                            break;
                        default:
                            result = result; // 0
                            break;
                    }
                    break;
                    case '0':
                        result = result; // 0
                        break;
            }
            break;
        case '7':
            switch (fireResistance) {
                case '30':
                    switch (framModel) {
                        case 'UB':
                        case 'UBS':
                        case 'EB-SST':
                        case 'EB-SV1':
                            result = wallThickness - 10;
                            break;
                        case 'EB':
                            result = wallThickness - 10;
                            break;
                        case 'EB-SV2':
                            result = wallThickness - 10;
                            break;
                        default:
                            result = result; // 0
                            break;
                    }
                    break;
                    case '0':
                        result = result; // 0
                        break;
            }
            break;
        default:
            result = result;
            break;
    }

    return result;
};

// // KTU_MM_TUERKERN
// export const getTuerkernLLTValue = (): ValueDefinition => {
//     let lltNumber: string = '0';
//
//     const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
//     const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);
//     const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
//     const soundProof = helper.GetDependencyValueCode('KTU_MM_FUNKTION_S', contex.ModelSelection);
//     const bulletProof = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BESCHUSS', contex.Functions);
//     const glassArt = helper.GetDependencyValueCode('KTU_MM_GLASART', contex.Functions);
//     const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
//     const topPanel = helper.HasTopPanel();
//
//     // FB3
//     if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '32' || soundProof === '35' || soundProof === '39' || soundProof === '42') &&
//                 bulletProof === 'FB3') {
//                     lltNumber = 'LLT100012';
//     } else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '4') &&
//             (soundProof === '32' || soundProof === '39') &&
//                 bulletProof === 'FB3') {
//                     lltNumber = 'LLT100012';
//     } // 'FB1-NS'
//     else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '32' || soundProof === '35' || soundProof === '39' || soundProof === '42') &&
//                 bulletProof === 'FB1-NS') {
//                     lltNumber = 'LLT100005';
//     } else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '4') &&
//             (soundProof === '32' || soundProof === '39') &&
//                 bulletProof === 'FB1-NS') {
//                     lltNumber = 'LLT100006';
//     } // GlassArt
//     else if (doorModel === 'CERT' &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '32' || soundProof === '39') &&
//                 glassArt !== '0') {
//                     if (doorWings === 'D1') {
//                         lltNumber = 'LLT100001';
//                     } else {
//                         lltNumber = 'LLT100001A';
//                     }
//     } else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '32' || soundProof === '35' || soundProof === '39' || soundProof === '42') &&
//                 glassArt !== '0') {
//                     lltNumber = 'LLT100005';
//     } else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '4') &&
//             (soundProof === '32' || soundProof === '39') &&
//                 glassArt !== '0') {
//                     lltNumber = 'LLT100006';
//     } // Oberblende
//     else if (doorModel === 'CERT' &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '32' || soundProof === '39') &&
//                 topPanel === true) {
//                     if (doorWings === 'D1') {
//                         lltNumber = 'LLT100001';
//                     } else {
//                         lltNumber = 'LLT100001A';
//                     } // if TopPanel then LLT100001B
//     } else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '32' || soundProof === '35' || soundProof === '39' || soundProof === '42') &&
//                 topPanel === true) {
//                     lltNumber = 'LLT100005'; // if TopPanel then LLT100005B
//     } else if (doorModel === 'BERT' &&
//         (resistanceClass === '4') &&
//             (soundProof === '32' || soundProof === '39') &&
//                 topPanel === true) {
//                     lltNumber = 'LLT100006'; // if TopPanel then LLT100006B
//     }
//     else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '42')) {
//                 lltNumber = 'LLT100009';
//     }
//     else if ((doorModel === 'CERT') &&
//         (resistanceClass === '2') &&
//             (soundProof === '39')) {
//                 if (doorWings === 'D1') {
//                     lltNumber = 'LLT100002';
//                 } else {
//                     lltNumber = 'LLT100002A';
//                 }
//     } else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '39')) {
//                 lltNumber = 'LLT100005';
//     } else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '4') &&
//             (soundProof === '39')) {
//                 lltNumber = 'LLT100006';
//     }
//     else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '2') &&
//             (soundProof === '35') &&
//                 fireResistance === '30') {
//                     lltNumber = 'LLT100011';
//     } else if ((doorModel === 'BERT') &&
//         (resistanceClass === '3') &&
//             (soundProof === '35') &&
//                 fireResistance === '30') {
//                     lltNumber = 'LLT100011';
//     } else if ((doorModel === 'VERT') &&
//         (resistanceClass === '3') &&
//             (soundProof === '35') &&
//                 fireResistance === '30') {
//                     lltNumber = 'LLT100005';
//     }
//     else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '32') &&
//                 fireResistance === '30') {
//                     lltNumber = 'LLT100011';
//     } else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '2' || resistanceClass === '3') &&
//             (soundProof === '32')) {
//                 lltNumber = 'LLT100004';
//     } else if ((doorModel === 'BERT' || doorModel === 'VERT') &&
//         (resistanceClass === '4') &&
//             (soundProof === '32')) {
//                 lltNumber = 'LLT100008';
//     } else if ((doorModel === 'CERT') &&
//         (resistanceClass === '2') &&
//             (soundProof === '32')) {
//                 if (doorWings === 'D1') {
//                     lltNumber = 'LLT100003';
//                 } else {
//                     lltNumber = 'LLT100003A';
//                 }
//     } else if ((doorModel === 'CERT') &&
//         (resistanceClass === '3') &&
//             (soundProof === '32')) {
//                 if (doorWings === 'D1') {
//                     lltNumber = 'LLT100001';
//                 } else {
//                     lltNumber = 'LLT100001A';
//                 }
//     }
//
//     let tuerkernCharacteristic: any;
//     let tuerkernValue: ValueDefinition;
//
//     if (lltNumber !== '0') {
//         tuerkernCharacteristic = store.state.frameModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_TUERKERN')[0];
//         tuerkernValue = tuerkernCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];
//     } else {
//         tuerkernValue = {
//             id: 0,
//             default: 0,
//             description: '0',
//             value: '0',
//             resource: '',
//         };
//     }
//
//     if (typeof tuerkernValue === 'undefined') {
//         tuerkernValue = {
//             id: 0,
//             default: 0,
//             description: '0',
//             value: '0',
//             resource: '',
//         };
//     }
//
//     return tuerkernValue;
// };
//
//
// export const getTuerkernLLTValueTest = (): ValueDefinition => {
//     let lltNumber: string = '0';
//     const artklnumber = helper.GetDependencyValueCode('KTU_MM_ARTIKELNR', contex.ModelSelection);
//     const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
//     const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);
//     const fireResistance = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
//     const soundProof = helper.GetDependencyValueCode('KTU_MM_FUNKTION_S', contex.ModelSelection);
//     const bulletProof = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BESCHUSS', contex.Functions);
//     const glassArt = helper.GetDependencyValueCode('KTU_MM_GLASART', contex.Functions);
//     const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
//     const topPanel = helper.HasTopPanel();
//
//     if(doorModel === 'CERT')
//     {
//         if(glassArt !== '0')
//         {
//             lltNumber = 'LLT100001';
//         }
//
//         // else if(topPanel)
//         // {
//         //     lltNumber = 'LLT100001B';
//         // }
//
//         else {
//             if(resistanceClass === '2')
//             {
//                 if(soundProof === '32')
//                 {
//                     lltNumber = 'LLT100003';
//                 }else {
//                     lltNumber = 'LLT100002';
//                 }
//             }else
//             {
//                 lltNumber = 'LLT100001';
//             }
//         }
//     }else if(doorModel === 'BERT')
//     {
//         if(bulletProof === 'FB3')
//         {
//             lltNumber = 'LLT100012';
//             // if(bulletProof === 'FB3')
//             // {
//             //     lltNumber = 'LLT100012';
//             // }else
//             // {
//             //     if(resistanceClass === '2' || resistanceClass === '3')
//             //     {
//             //         lltNumber =  'LLT100005';
//
//             //     }else {
//             //         lltNumber = 'LLT100006';
//             //     }
//             // }
//         }else if(glassArt !== '0')
//         {
//             if(resistanceClass === '2' || resistanceClass === '3')
//             {
//                 lltNumber =  'LLT100005';
//
//             }else {
//                 lltNumber = 'LLT100006';
//             }
//         }
//
//         // else if(topPanel)
//         // {
//         //     if(resistanceClass === '2' || resistanceClass === '3')
//         //     {
//         //         lltNumber =  'LLT100005B';
//
//         //     }else {
//         //         lltNumber = 'LLT100006B';
//         //     }
//         // }
//
//         else {
//             if(soundProof === '32')
//             {
//                 if(artklnumber.startsWith('TW-BERT200'))
//                 {
//                     lltNumber = 'LLT100004'
//                 }else if(artklnumber.startsWith('TW-BERT230'))
//                 {
//                     lltNumber = 'LLT100011';
//                 }else if(artklnumber.startsWith('TW-BERT300'))
//                 {
//                     lltNumber = 'LLT100004'
//                 }else if(artklnumber.startsWith('TW-BERT330'))
//                 {
//                     lltNumber = 'LLT100011';
//                 }else {
//                     lltNumber = 'LLT100008';
//                 }
//             }else if(soundProof == '35')
//             {
//                 lltNumber = 'LLT100011';
//             }else if(soundProof == '39'){
//                 if(resistanceClass === '2' || resistanceClass === '3')
//                 {
//                     lltNumber = 'LLT100005';
//                 }else {
//                     lltNumber = 'LLT100006';
//                 }
//             }else {
//                 lltNumber = 'LLT100009';
//             }
//         }
//     }else {
//         if(bulletProof === 'FB3')
//         {
//             lltNumber = 'LLT100012';
//
//         }else if(glassArt !== '0')
//         {
//             if(resistanceClass === '2' || resistanceClass === '3')
//             {
//                 lltNumber =  'LLT100005';
//
//             }else {
//                 lltNumber = 'LLT100006';
//             }
//         }
//
//         // else if(topPanel)
//         // {
//         //     lltNumber =  'LLT100005B';
//         // }
//
//         else {
//             if(soundProof === '32')
//             {
//                 if(artklnumber.startsWith('TW-VERT200'))
//                 {
//                     lltNumber = 'LLT100004';
//                 }else if(artklnumber.startsWith('TW-VERT230'))
//                 {
//                     lltNumber = 'LLT100011';
//                 }else if(artklnumber.startsWith('TW-VERT300'))
//                 {
//                     lltNumber = 'LLT100004';
//                 }else if(artklnumber.startsWith('TW-VERT330'))
//                 {
//                     lltNumber = 'LLT100011';
//                 }else {
//                     lltNumber = 'LLT100008';
//                 }
//             }else if(soundProof === '35')
//             {
//                 if(artklnumber.startsWith('TW-VERT230'))
//                 {
//                     lltNumber = 'LLT100011';
//                 }else {
//                     lltNumber = 'LLT100005';
//                 }
//             }else if(soundProof === '39')
//             {
//                 if(resistanceClass === '2' || resistanceClass === '3')
//                 {
//                     lltNumber = 'LLT100005';
//                 }else {
//                     lltNumber = 'LLT100006';
//                 }
//             }else { //if soundproof 42
//                 lltNumber = 'LLT100009';
//             }
//         }
//     }
//
//     let tuerkernCharacteristic: any;
//     let tuerkernValue: ValueDefinition;
//
//     if (lltNumber !== '0') {
//         tuerkernCharacteristic = store.state.frameModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_TUERKERN')[0];
//         tuerkernValue = tuerkernCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];
//     } else {
//         tuerkernValue = {
//             id: 0,
//             default: 0,
//             description: '0',
//             value: '0',
//             resource: '',
//         };
//     }
//
//     if (typeof tuerkernValue === 'undefined') {
//         tuerkernValue = {
//             id: 0,
//             default: 0,
//             description: '0',
//             value: '0',
//             resource: '',
//         };
//     }
//
//     return tuerkernValue;
// };

// KTU_MM_TUERKERN
export const getTuerkernLLTValue = (): ValueDefinition => {
    let lltNumber: string = '0';
    const bulletProof = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BESCHUSS', contex.Functions);
    const glassArt = helper.GetDependencyValueCode('KTU_MM_GLASART', contex.Functions);
    const soundProof = helper.GetDependencyValueCode('KTU_MM_FUNKTION_S', contex.ModelSelection);
    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const artklnumber = helper.GetDependencyValueCode('KTU_MM_ARTIKELNR', contex.ModelSelection);
    const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);

    if(bulletProof === 'FB3') {
        lltNumber = 'LLT100012';
    }
    else {
        if(glassArt !== '0') {
            if(doorModel === 'CERT') {
                if(resistanceClass === '2' || resistanceClass === '3') {
                    if(doorWings === 'D1') {
                        lltNumber = 'LLT100001';
                    }
                    else if(doorWings === 'D2') {
                        lltNumber = 'LLT100001A';
                    }
                }
            }
            else {
                if(resistanceClass === '2' || resistanceClass === '3'){
                    lltNumber = 'LLT100005';
                }
                else if (resistanceClass === '4') {
                    lltNumber = 'LLT100006';
                }
            }
        }
        else {
            if(soundProof === '32') {
                if(doorModel === 'CERT') {
                    if(artklnumber.startsWith('TW-CERT200')) {
                        if(doorWings === 'D1') {
                            lltNumber = 'LLT100003';
                        }
                        else if(doorWings === 'D2') {
                            lltNumber = 'LLT100003A';
                        }
                    }
                    else if(artklnumber.startsWith('TW-CERT300')) {
                        if(doorWings === 'D1') {
                            lltNumber = 'LLT100001';
                        }
                        else if(doorWings === 'D2') {
                            lltNumber = 'LLT100001A';
                        }
                    }
                }
                else if (doorModel === 'BERT') {
                    if(artklnumber.startsWith('TW-BERT200')) {
                        lltNumber = 'LLT100004';
                    }
                    else if(artklnumber.startsWith('TW-BERT230')) {
                        lltNumber = 'LLT100011';
                    }
                    else if(artklnumber.startsWith('TW-BERT300')) {
                        lltNumber = 'LLT100004';
                    }
                    else if(artklnumber.startsWith('TW-BERT330')) {
                        lltNumber = 'LLT100011';
                    }
                    else if(artklnumber.startsWith('TW-BERT400')) {
                        lltNumber = 'LLT100008';
                    }
                }
                else if (doorModel === 'VERT') {
                    if(artklnumber.startsWith('TW-VERT200')) {
                        lltNumber = 'LLT100004';
                    }
                    else if(artklnumber.startsWith('TW-VERT230')) {
                        lltNumber = 'LLT100011';
                    }
                    else if(artklnumber.startsWith('TW-VERT300')) {
                        lltNumber = 'LLT100004';
                    }
                    else if(artklnumber.startsWith('TW-VERT330')) {
                        lltNumber = 'LLT100011';
                    }
                    else if(artklnumber.startsWith('TW-VERT400')) {
                        lltNumber = 'LLT100008';
                    }
                }
            }
            else if(soundProof === '35') {
                if(doorModel === 'BERT') {
                    if(artklnumber.startsWith('TW-BERT230') || artklnumber.startsWith('TW-BERT330')) {
                        lltNumber = 'LLT100011';
                    }
                }
                else if(doorModel === 'VERT') {
                    if(artklnumber.startsWith('TW-VERT230')) {
                        lltNumber = 'LLT100011';
                    }
                    else if(artklnumber.startsWith('TW-VERT330')) {
                        lltNumber = 'LLT100005';
                    }
                }
            }
            else if(soundProof === '39') {
                if(doorModel === 'CERT') {
                    if(artklnumber.startsWith('TW-CERT200')) {
                        if(doorWings === 'D1') {
                            lltNumber = 'LLT100002';
                        }
                        else if(doorWings === 'D2') {
                            lltNumber = 'LLT100002A';
                        }
                    }
                }
                else if(doorModel === 'BERT') {
                    if(artklnumber.startsWith('TW-BERT200') ||
                        artklnumber.startsWith('TW-BERT230') ||
                        artklnumber.startsWith('TW-BERT300') ||
                        artklnumber.startsWith('TW-BERT330')
                    ) {
                        lltNumber = 'LLT100005';
                    }
                    else if(artklnumber.startsWith('TW-BERT400') || artklnumber.startsWith('TW-BERT430')) {
                        lltNumber = 'LLT100006';
                    }
                }
                else if(doorModel === 'VERT') {
                    if(artklnumber.startsWith('TW-VERT200') ||
                        artklnumber.startsWith('TW-VERT230') ||
                        artklnumber.startsWith('TW-VERT300') ||
                        artklnumber.startsWith('TW-VERT330')
                    ) {
                        lltNumber = 'LLT100005';
                    }
                    else if(artklnumber.startsWith('TW-VERT400') || artklnumber.startsWith('TW-VERT430')) {
                        lltNumber = 'LLT100006';
                    }
                }
            }
            else if(soundProof === '42') {
                if(doorModel === 'BERT') {
                    if(artklnumber.startsWith('TW-BERT200') ||
                        artklnumber.startsWith('TW-BERT230') ||
                        artklnumber.startsWith('TW-BERT300') ||
                        artklnumber.startsWith('TW-BERT330')
                    ) {
                        lltNumber = 'LLT100009';
                    }
                }
                else if(doorModel === 'VERT') {
                    if(artklnumber.startsWith('TW-VERT200') ||
                        artklnumber.startsWith('TW-VERT230') ||
                        artklnumber.startsWith('TW-VERT300') ||
                        artklnumber.startsWith('TW-VERT330')
                    ) {
                        lltNumber = 'LLT100009';
                    }
                }
            }
        }
    }

    let tuerkernValue: ValueDefinition;

    if (lltNumber !== '0') {
        let tuerkernCharacteristic = store.state.frameModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_TUERKERN')[0];
        tuerkernValue = tuerkernCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];
    } else {
        tuerkernValue = {
            id: 0,
            default: 0,
            description: '0',
            value: '0',
            resource: '',
        };
    }

    if (typeof tuerkernValue === 'undefined') {
        tuerkernValue = {
            id: 0,
            default: 0,
            description: '0',
            value: '0',
            resource: '',
        };
    }

    return tuerkernValue;
};
